import { Injectable } from '@angular/core';
import { SpecialtyConfig } from '../models/specialty-config.model';
import { LocaleService } from './locale.service';
import { RequestService } from './request.service';
import { HttpClient } from '@angular/common/http';
import { CustomQuestion } from '../models/custom-question.model';
import { PatientService } from './patient.service';
import * as _ from 'lodash';
import { firstValueFrom } from 'rxjs';
import { IntegrationType } from '../enums/integration-type.enum';
import { RegistrationService } from './registration.service';
import { Provider } from '../models/provider.model';

@Injectable({
  providedIn: 'root'
})
export class ProviderService {
  providerLanus = ["63d3f6cae0a97800915a804f", "63a3461dd21709009859ad29"];

  constructor(
    private requestService: RequestService,
    private localeService: LocaleService,
    private httpClient: HttpClient,
    private patientService: PatientService,
    private registrationService: RegistrationService,
  ) { }

  getBasicRegistrationInfo(): Promise<Provider[]> {
    return this.requestService.get('/provider/basicRegistrationInfo');
  }

  getOneBasicRegistrationInfo(providerId: string) {
    return this.requestService.get(`/provider/${providerId}/basicRegistrationInfo`)
  }

  getTermsAndConditions(providerId:string){
    const locale = this.getLocaleCode();
    return this.requestService.get('/provider/' + providerId + '/tyc?locale=' + locale)
  }

  getSatisfactionSurveyQuestions(providerId: string): Promise<any> {
    return this.requestService.get(`/provider/${providerId}/satisfactorySurveyQuestions?localeCode=${this.getLocaleCode()}`)
  }

  getProviderSpecialtyConfig(providerId: string): Promise<SpecialtyConfig[]> {
    return this.requestService.get(`/specialtyProviderConfig/provider/${providerId}`)
  }

  getLocaleCode(): string {
    return this.localeService.getLocale().toLowerCase().split("-")[0]; //Send only language code
  }

  getDefaultCustomQuestions(): Promise<CustomQuestion[]> {
    return firstValueFrom(this.httpClient.get<CustomQuestion[]>('assets/data/default-questions.data.json'));
  }

  isLanus(providerId: string): boolean {
    return this.providerLanus.includes(providerId);
  }

  async supportsOnCall(): Promise<boolean> {
    const provider = await this.patientService.getProvider();
    return provider.supportsOnCall || _.isUndefined(provider.supportsOnCall);
  }

  async supportsAppointmentBooking(): Promise<boolean> {
    const provider = await this.patientService.getProvider();
    return provider.allowPatientAppointmentBooking || _.isUndefined(provider.allowPatientAppointmentBooking);
  }

  isToken(provider?: Provider): boolean {
    provider = provider || this.registrationService.getProvider();
    return provider?.serviceObjectName === IntegrationType.PROVIDER_TOKEN_SERVICE;
  }
}
